<template>
  <div>    
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2 class="pb-5">
            {{ this.pageTitle
            }}<span class="page_title_value">{{ this.pageTitleValue }}</span>
          </h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5">
              <v-autocomplete
                outlined
                :label="this.$t('arrearsexercise.bpexercisedesc')"
                type="text"
                :rules="[rules.required]"
                :items="arrearsList"
                v-model="id"
                @change="changeArrear(id)"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" sm="4" class="pb-n5">
              <v-text-field
                outlined
                :label="this.$t('arrearsexercise.bpexercisecode')"
                type="text"
                v-model="bpexercisecode"
                dense
                readonly
                background-color="#ffeab2"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2" sm="2" class="pb-n5 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('arrearsexercise.inceffdate')"
                type="date"
                v-model="inceffdate"
                dense
                readonly
                background-color="#ffeab2"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" class="pb-n5 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('arrearsexercise.actinceffdate')"
                type="date"
                v-model="actinceffdate"
                dense
                readonly
                background-color="#ffeab2"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" class="pb-n5 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('arrearsexercise.servicedate')"
                type="date"
                v-model="servicedate"
                dense
                readonly
                background-color="#ffeab2"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
              <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                  <v-text-field
                  dense
                  outlined
                  :label="this.$t('statutoryexportcommonused.payoutdescription')"
                  v-model="posttopayoutdesc"
                  readonly
                  background-color="#ffeab2"
                  ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                  <v-text-field
                  dense
                  :label="this.$t('columns.code')"
                  outlined
                  readonly
                  background-color="#ffeab2"
                  v-model="posttopayout"
                  ></v-text-field>
              </v-col>
          </v-row>

        </v-container>
        <v-row>
          <div class="pt-5 pl-4">
            <v-btn color="primary" style="width: 120px;margin-bottom: 20px;" @click="onPost"
              >{{$t('button.post')}}</v-btn
            >
            <v-btn color="primary" style="width: 120px;margin-bottom: 20px;margin-left: 20px;" @click="onUnPost">
              {{$t('button.undoposting')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {

  components: {
    "app-error": ErrorDialog,
    Loading,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      pageTitle: this.$t('arrearsexercise.posting'),
      pageTitleValue: "",

      id: null,
      bpexercisecode: null,
      inceffdate: null,
      actinceffdate: null,
      servicedate: null,
      posttopayoutid: null,
      posttopayoutstartdate: null,
      posttopayoutenddate: null,
      posttopayout: null,
      posttopayoutdesc: null,
      loading: false,

      payoutstatusList: [],
      arrears: [],
      arrearsList: [],

      errMsg: "",
      isErr: false,
      editMode: false,

      parameters: {
          staffid: null,
          gradeid: null,
          employmenttypeid: null,
          companyid: null,
          branchid: null,
          departmentid: null
      },
      showFilter: {
          staffid: true,
          gradeid: true,
          employmenttypeid: true,
          companyid: true,
          branchid: true,
          departmentid: true
      },
    };
  },

  methods: {

    loadArrearsListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
        url:  '/arrearsexercise/all'
        })
        .then((res) => {
          vm.arrears = res.data.rec;

          for (let i = 0; i < vm.arrears.length; i++) {
            if (vm.arrears[i].inceffdate) {
              vm.arrears[i].inceffdate = moment(
                vm.arrears[i].inceffdate
              ).format("YYYY-MM-DD");
            }

            if (vm.arrears[i].actinceffdate) {
              vm.arrears[i].actinceffdate = moment(
                vm.arrears[i].actinceffdate
              ).format("YYYY-MM-DD");
            }

            if (vm.arrears[i].servicedate) {
              vm.arrears[i].servicedate = moment(
                vm.arrears[i].servicedate
              ).format("YYYY-MM-DD");
            }
            
            if (vm.arrears[i].posttopayoutstartdate) {
              vm.arrears[i].posttopayoutstartdate = moment(
                vm.arrears[i].posttopayoutstartdate
              ).format("YYYY-MM-DD");
            }
            if (vm.arrears[i].posttopayoutenddate) {
              vm.arrears[i].posttopayoutenddate = moment(
                vm.arrears[i].posttopayoutenddate
              ).format("YYYY-MM-DD");
            }

            vm.arrearsList.push({
              text: vm.arrears[i].bpexercisedesc,
              value: vm.arrears[i].id,
            });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },


    changeArrear(id) {
      let item = this.arrears.find((item) => item.id == id);

      this.bpexercisecode = item.bpexercisecode;
      this.inceffdate = item.inceffdate;
      this.actinceffdate = item.actinceffdate;
      this.servicedate = item.servicedate;
      this.posttopayoutid = item.posttopayoutid;
      this.posttopayoutstartdate = item.posttopayoutstartdate;
      this.posttopayoutenddate = item.posttopayoutenddate;
      this.posttopayout = item.posttopayout;
      this.posttopayoutdesc = item.posttopayoutdesc;

    },
    onPost() {
      // run process
      //const vm = this
      if (!this.isErr && this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch('post', {url: "/arrears/post",
          payload: {"id": this.id, "posttopayoutid": this.posttopayoutid, "actinceffdate": this.actinceffdate
          , "userid": this.$store.getters.userId}})
          .then((res) => {
            console.log(res);
            this.loading = false;
            if (res.data.status == 400 || res.data.status == 409) {
              this.isErr = !this.isErr;
              this.errMsg = res.data.error;
            } else {
              let item = {
                processedCount: res.data.rec.posted,
                staffprocessedCount: res.data.rec.staffprocess,
                totalPosted: res.data.rec.posted,
              }
              this.$router.push({ name: "arrearspostinglog", params: { item } });
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
    onUnPost() {
      if (!this.isErr && this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch('post', {url: "/arrears/unpost",
          payload: {"id": this.id, "posttopayoutid": this.posttopayoutid
          , "userid": this.$store.getters.userId}})
          .then((res) => {
            console.log(res);
            this.loading = false;
            if (res.data.status == 400 || res.data.status == 409) {
              this.isErr = !this.isErr;
              this.errMsg = res.data.error;
            } else {
              let item = {
                processedCount: res.data.rec.unposted,
                staffprocessedCount: res.data.rec.staffprocess,
                totalUnPosted: res.data.rec.unposted,
              }
              this.$router.push({ name: "arrearspostinglog", params: { item } });
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
  },

  mounted() {
    this.loadArrearsListHandler();
  },
};
</script>